import { createFileRoute } from '@tanstack/react-router'
import { CustomerBillingPage } from '@/features/customer/pages/billing'

export const Route = createFileRoute('/_authenticated/customer/billing')({
  component: CustomerBillingPage,
})
